<template>
  <div class="sirui-cloumn">
    <div class="vxe-tools--operate">
      <div
        class="vxe-custom--wrapper"
        ref="customWrapper"
        :class="{ 'is--active': customStore.visible }"
      >
        <div :title="$t('xTable.toolbar.custom')" class="vxe-tools--operate-btn">
          <img
            class="sirui-img"
            src="../../assets/tableImg/menu.svg"
            alt=""
            @click="toolbarButtonClickEvent"
          />
        </div>
        <div class="vxe-custom--option-wrapper">
          <div class="vxe-custom--header" @click="allCustomEvent">
            <li
              :title="$t('xTable.toolbar.allTitle')"
              :class="{
                'is--checked': customStore.isAll,
                'is--indeterminate': customStore.isIndeterminate,
              }"
              >{{ $t('xTable.toolbar.customAll') }}</li
            >
          </div>
          <ul class="vxe-custom--body">
            <template v-for="(item, index) in tableFullColumn">
              <li
                :key="index"
                :title="$t(item.title)"
                v-if="!(item.type == 'checkbox' || item.type == 'radio' || item.type == 'seq')"
                class="vxe-custom--option"
                :class="{
                  'is--checked': item.visible,
                  'is--disabled': customOpts.checkMethod
                    ? !customOpts.checkMethod({
                        column: item,
                      })
                    : false,
                }"
                @click="singleCustomEvent(item, index)"
                >{{ $t(item.title) }}</li
              >
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import _tools from 'vxe-table/lib/tools';
  import BASE_API from '@/api/dataBase.js';
  import XEUtils from 'xe-utils';
  export default {
    name: 'SiruiColumns',
    props: {
      //是否需要自定义列
      setting: {
        type: Boolean,
        default: true,
      },
      //所有列
      columns: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableFullColumn: this.columns,
        customStore: {
          isAll: false,
          isIndeterminate: false,
          visible: false,
        },
      };
    },
    watch: {
      columns(newValue) {
        this.tableFullColumn = newValue;
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //immediate: false 设置不及时更新 为了防止请求次数过多
      customOpts: function customOpts() {
        return Object.assign({}, this.setting ? { immediate: false } : {});
      },
    },
    created() {
      //绑定鼠标点击事件
      _tools.GlobalEvent.on(this, 'mousedown', this.handleGlobalMousedownEvent);
      //绑定失去焦点事件
      _tools.GlobalEvent.on(this, 'blur', this.handleGlobalBlurEvent);
    },
    methods: {
      toolbarButtonClickEvent() {
        this.customStore.visible = !this.customStore.visible;
        this.checkCustomStatus();
      },
      checkCustomStatus() {
        var checkMethod = this.customOpts.checkMethod;
        var tableFullColumn = this.tableFullColumn;
        this.customStore.isAll = tableFullColumn.every(function (column) {
          return (
            (checkMethod
              ? !checkMethod({
                  column: column,
                })
              : false) || column.visible
          );
        });
        this.customStore.isIndeterminate =
          !this.customStore.isAll &&
          tableFullColumn.some(function (column) {
            return (
              (!checkMethod ||
                checkMethod({
                  column: column,
                })) &&
              column.visible
            );
          });
      },
      handleGlobalMousedownEvent(evnt) {
        if (!_tools.DomTools.getEventTargetNode(evnt, this.$refs.customWrapper).flag) {
          this.closeCustom();
        }
      },
      handleGlobalBlurEvent() {
        this.closeCustom();
      },
      closeCustom() {
        if (this.customStore.visible) {
          this.customStore.visible = false;
          if (this.setting && !this.customStore.immediate) {
            this.handleCustoms();
          }
        }
      },
      handleCustoms() {
        const list = this.tableFullColumn.map((item) => {
          return Object.assign({}, item);
        });
        this.$emit('setColumns', list);
        return this.getMenuCode();
      },
      //获取当前menuCode
      getMenuCode() {
        //先要获取当前路由的菜单code
        this.getRouteMenuCode().then((e) => {
          this.saveColumnHide(e);
        });
      },
      //调用接口保存用户列配置
      saveColumnHide(e) {
        var cusotmColumn = this.$emit('getTableColumn');
        const baseInfo = {
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          departmentCode: this.userInfo.userInfo.departmentCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentName: this.userInfo.userInfo.departmentName,
          userId: this.userInfo.userInfo.userCode,
          menuCode: e,
        };
        var flag = false;
        cusotmColumn.tableFullColumn.forEach((item) => {
          if (item.type != 'checkbox' && item.visible) {
            flag = true;
          }
        });
        const list = cusotmColumn.tableFullColumn.map((item, index) => {
          return Object.assign(
            {},
            {
              ...baseInfo,
              sortNum: index,
              field: item.field,
              title: item.type == 'seq' ? 'table.index' : this.getField(item.field),
              visible: item.type == 'checkbox' ? flag : item.visible,
              sortable: item.sortable,
              type: item.type,
              width: item.width,
              fixed: item.fixed,
            }
          );
        });
        // TODO 单独处理title丢失的时候提交问题
        let titleFlag = false;
        for (const item of list) {
          if (item.type == 'checkbox') continue;
          if (!item.title) {
            titleFlag = false;
          } else {
            titleFlag = true;
          }
        }
        if (!titleFlag) {
          return;
        }
        this.loading.startLoading();
        this.$axios.post(BASE_API.ADD_COLUMNS_API, list).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            return this.$nextTick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //获取列名
      getField(value, valueProp = 'field', labelField = 'title') {
        if (value) {
          let item = XEUtils.find(this.columns, (item) => item[valueProp] == value);
          return item ? item[labelField] : null;
        } else {
          return null;
        }
      },

      allCustomEvent() {
        var checkMethod = this.customOpts.checkMethod;
        var isAll = !this.customStore.isAll;
        this.tableFullColumn.forEach(function (column) {
          if (
            !checkMethod ||
            checkMethod({
              column: column,
            })
          ) {
            column.visible = isAll;
          }
        });
        this.customStore.isAll = isAll;
        this.checkCustomStatus();
      },
      singleCustomEvent(column, index) {
        column.visible = !column.visible;
        this.tableFullColumn[index] = column;
        if (this.setting && this.customOpts.immediate) {
          this.handleCustoms();
        }
        this.checkCustomStatus();
      },
    },
    destroyed: function destroyed() {
      _tools.GlobalEvent.off(this, 'mousedown');

      _tools.GlobalEvent.off(this, 'blur');
    },
  };
</script>
<style lang="scss">
  .vxe-toolbar .vxe-tools--operate-btn:hover {
    background: scale-color(#fff, $lightness: 2%) !important;
    border-radius: 0 !important;
  }

  .vxe-toolbar .vxe-tools--operate-btn {
    padding: 0 8px 0 0;
  }
</style>
<style lang="scss" scoped>
  .sirui-cloumn {
    height: 30px;
    width: 30px;
    line-height: 30px;
    border: 1px solid #e4e6eb;
    border-radius: 3px;
    margin-left: 10px;

    .sirui-img {
      //padding: 8px 8px ;
    }

    //.vxe-custom--option-wrapper {
    //  background-color: #000000;
    //  color: #FFFFFF;
    //}
    .vxe-custom--option {
      height: 30px;
      line-height: 30px;
    }

    .is--checked {
      color: #00b400;
    }

    //.vxe-custom--header {
    //  height: 30px;
    //  line-height: 30px;
    //  padding: 0;
    //  border: 0;
    //  li {
    //    padding:0 2.3em;
    //  }
    //}
    //.vxe-custom--body {
    //  padding: 0;
    //}
  }
</style>
